import { Badge } from '@bpinternal/ui-kit-next'
import { TrafficCone } from 'lucide-react'
import { cn } from '~/utils'

type Props = {
  children: React.ReactNode
  className?: string
}

export const ComingSoon = ({ children, className }: Props) => {
  return (
    <div className={cn('relative rounded-lg border border-border ', className)}>
      <div className="blur-sm">{children}</div>
      <div className="absolute inset-0 z-50 flex items-center justify-center">
        <Badge variant="outline" className="flex gap-2 bg-background p-2 text-foreground">
          <TrafficCone size={16} />
          Coming Soon
        </Badge>
      </div>
    </div>
  )
}
